import { colors } from "#app/theme/v1/colors";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { ConceptionSection } from "#modules/quoteRequestLines/views/DetailsPanel/Conception/ConceptionSection";
import MarginsSection from "#modules/quoteRequestLines/views/DetailsPanel/Margins/MarginsSection";
import { MaterialSection } from "#modules/quoteRequestLines/views/DetailsPanel/Material/MaterialSection";
import { ProcessStepsSection } from "#modules/quoteRequestLines/views/DetailsPanel/ProcessSteps/ProcessStepsSection";
import { ProcessStepForTable } from "#modules/quoteRequestLines/views/DetailsPanel/ProcessSteps/ProcessStepsTable";
import { ProductsSection } from "#modules/quoteRequestLines/views/DetailsPanel/Products/ProductsSection";
import { Stack } from "#shared/view/components/Stack";
import { Title } from "#shared/view/components/Title";
import { AssemblyWithChildren } from "shared";

type Props = {
  title: string;
  quoteRequestLine: QuoteRequestLineDto;
  assemblyChildren: AssemblyWithChildren<QuoteRequestLineDto>[];
  hasChildren: boolean;
  isChild: boolean;
  processSteps: ProcessStepForTable[];
};

export const DetailsPanelCosts = ({
  title,
  quoteRequestLine,
  assemblyChildren,
  hasChildren,
  isChild,
  processSteps,
}: Props) => {
  return (
    <Stack gap="xs">
      <Title order={1} color={colors.gray[6]}>
        {title}
      </Title>
      <Stack gap="xs">
        <ConceptionSection />
        {!hasChildren && (
          <MaterialSection
            quoteRequestLine={quoteRequestLine}
            hasChildren={hasChildren}
            isChild={isChild}
          />
        )}
        <ProcessStepsSection
          assemblyChildren={assemblyChildren}
          hasChildren={hasChildren}
          processSteps={processSteps}
        />
        <ProductsSection quoteRequestLine={quoteRequestLine} />
        <MarginsSection quoteRequestLine={quoteRequestLine} />
      </Stack>
    </Stack>
  );
};
